import { Component, Input, ContentChildren, QueryList, ViewChild } from '@angular/core';

import { DataTableColumnDirective, DatatableComponent } from "@swimlane/ngx-datatable";

import './fix';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss']
})
export class TableComponent {
    @Input() headerHeight = 40;
    @Input() data: any; // Data model to get the date from
    @Input() messages =
    {
        // Message to show when array is presented
        // but contains no values
        emptyMessage: 'No existen registros',

        // Footer total message
        totalMessage: ''
    };

    // ref: https://github.com/swimlane/ngx-datatable/issues/1299
    @ViewChild(DatatableComponent) datatable: DatatableComponent;
    @ContentChildren(DataTableColumnDirective) val: QueryList<DataTableColumnDirective>;
    ngOnInit() {
        // workaround of ng-content
        setTimeout(() => {
            this.datatable.columnTemplates = this.val;
        });
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/table/table.component.ts